import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../reducers/form';
import * as api from '../../../api/list'
import validateProps from '../../../functions/validateProps'
import { enqueueSnackbar } from '../../../reducers/notifier'
import SimpleAdd from '../../../components/SimpleAdd'


export default function ResourcesAdd({ history }) {
  const dispatch = useDispatch()
  const formName = 'ResourcesAdd'
  useEffect(() => {
    dispatch(actions.formInitialize({ name: '', errorValidate: { name: false } }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form
  const arrProps = [
    { field: 'name', label: 'Наименование', type: 'text', validator: [value => value !== ''], errorText: 'Поле обязательно' },
    {
      field: 'resource', type: 'autoLoad', label: 'Папка',
      textProps: {
        path: api.getResources.path+'?folder=1',
        meta: {
          field: 'resource',
          value: 'id',
          labelFunc: (obj) => obj.name
        },
        selectProps: { isClearable: true },
      }
    },
    {
      field: 'type', type: 'autoArr', label: 'Тип',
      validator: [value => !!value], errorText: 'Поле обязательно',
      textProps: { arr: [{ value: 'labor', label: 'Люди' }, { value: 'machine', label: 'Машины' }], defaultValue: 'labor', },
    },
    { field: 'price', label: 'Стоимость за ед', type: 'text', textProps: { type: 'number' } },
  ]
  const handleSave = (e) => {
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: { name: values.name, type: values.type, price: values.price, parentId: values.resource },
      url: api.addResources.path,
      method: api.addResources.type,
      history: history
    }, formName))
  };
  return (
    <div className='App-paper'>
      <form autoComplete="off" onSubmit={handleSave}>
        <div style={{ padding: '16px' }}>
          <SimpleAdd
            arr={arrProps}
            formName={formName}
            title='Добавить ресурс'
          />
        </div>
        <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
        <Button type="submit" color="primary">Сохранить</Button>
      </form>
    </div>
  );
}
